import { Box } from "@mui/material";
import { colors, spacing } from "../../../../assets/styles/tokens";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import LeadMobileCard from "./LeadMobileCard";

interface LeadsMobileCardListProps {
  data: LeadsManagementData;
}

export default function LeadsMobileCardList({ data }: LeadsMobileCardListProps) {
  const { pageLeads, openLeadDetail, openBrandMatch, goToFilteredLeads } = data;

  if (pageLeads.length === 0) {
    return (
      <Box sx={{ py: spacing.Spacing["6xl"].$value, textAlign: "center", color: colors.GrayLightMode[400].$value, fontSize: 14 }}>
        No leads match the current filters.
      </Box>
    );
  }

  return (
    <Box sx={{ pb: spacing.Spacing["3xl"].$value }}>
      {pageLeads.map((lead) => (
        <LeadMobileCard
          key={lead.id}
          lead={lead}
          onOpenDetail={() => openLeadDetail(lead.id)}
          onOpenBrandMatch={() => openBrandMatch(lead.id)}
          onViewSharedIp={() => lead.ipAddress && goToFilteredLeads({ search: lead.ipAddress })}
        />
      ))}
    </Box>
  );
}
